import React, { Component } from 'react';
import ProductItem from '../ProductItem';

class ProductList extends Component {
  render() {
    const {
      products,
      id,
      handleCallbackStatus,
      toggleListProductItem,
      productAction,
      onClickProductActions,
      isProductDragDisabled,
      categories,
      editProduct,
    } = this.props;

    return products.map((item, index) => (
      <ProductItem
        {...item}
        product={item}
        categories={categories}
        status={item.status}
        categoryId={id}
        key={`product_list_${item.name}_${item.id}`}
        callbackStatus={handleCallbackStatus}
        index={index}
        toggleListProductItem={toggleListProductItem}
        productAction={productAction}
        onClickProductActions={onClickProductActions}
        isProductDragDisabled={isProductDragDisabled}
        editProduct={editProduct}
      />
    ));
  }
}

export default ProductList;



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/ProductList/index.js